
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/owner/settings",
      function () {
        return require("private-next-pages/owner/settings.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/owner/settings"])
      });
    }
  